import React from 'react';
import { IonButton, IonIcon, IonReorder } from '@ionic/react';
import { checkmarkCircleOutline, chevronForwardOutline, removeCircleOutline, reorderTwo, trashOutline } from 'ionicons/icons';
import GridStatus from './GridStatus';

type Props = {
  item: { pergunta: string; tipo: string; categoria: string; obrigatorio: string };
  canEdit: boolean;
  canReorder: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onRequired: () => void;
};

export default function FormularioRow({ item, canEdit, canReorder, onEdit, onDelete, onRequired }: Props) {
  const required = item.obrigatorio === 'sim';
  return <div className={`config-question-row ${canReorder ? 'has-reorder' : ''} ${canEdit ? 'is-editable' : ''}`}
    tabIndex={canEdit ? 0 : undefined} aria-label={canEdit ? `Editar ${item.pergunta}` : undefined}
    onClick={() => { if (canEdit) onEdit(); }}
    onKeyDown={event => {
      if (event.target === event.currentTarget && canEdit && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault(); onEdit();
      }
    }}>
    {canReorder && <div className="config-order" onClick={event => event.stopPropagation()}>
      <IonReorder className="list-reorder-handle" aria-label={`Ordenar ${item.pergunta || 'item'}`}><IonIcon icon={reorderTwo} aria-hidden="true" /></IonReorder>
    </div>}
    <strong className="config-question-name">{item.pergunta}</strong>
    <div className="config-question-meta"><span className="config-question-type">{({ text: 'Texto', select: 'Seleção', image: 'Fotos', signature: 'Assinaturas' } as Record<string, string>)[item.tipo] || item.tipo}</span>
    <span className="config-question-category">{item.categoria}</span></div>
    <div className="config-question-required" onClick={event => event.stopPropagation()}>
      <button className="config-status-button" type="button" onClick={onRequired} aria-label={`Obrigatório: ${required ? 'Sim' : 'Não'}`}>
        <GridStatus tone={required ? 'success' : 'neutral'} icon={required ? checkmarkCircleOutline : removeCircleOutline}>{required ? 'Obrigatório' : 'Opcional'}</GridStatus>
      </button>
    </div>
    <div className="config-row-actions">
      {canEdit && <><span onClick={event => event.stopPropagation()}><IonButton fill="clear" className="config-delete" aria-label={`Excluir ${item.pergunta}`} onClick={onDelete}><IonIcon slot="icon-only" icon={trashOutline} /></IonButton></span><IonIcon className="config-chevron" icon={chevronForwardOutline} aria-hidden="true" /></>}
    </div>
  </div>;
}
